import PaymentLogs from 'app/collections/payment_logs';

import Base from 'app/views/base';

import { List as ListView } from 'app/components/list/list';
import { buildHeadings } from 'app/components/pages/payment_logs'

import tmpl from './template';

export const PAGE_SIZE = 10;

export default Base.extend({
  compiledTemplate: tmpl,
  className: 'cash-flow',

  initialize({ paymentMethods, user }) {
    this.user = user;
    this.paymentMethods = paymentMethods;
    this.collection = new PaymentLogs([], {
      pageSize: PAGE_SIZE, staticParams: { target_type: 'easypost_stripe' }
    });

    this.addSubview('paymentLogList', '#payment_log_list', new ListView({
      headings: buildHeadings(this.user),
      collection: this.collection,
      noResultsMessage: 'No payment logs are available to view.',
    }));
  },
});



// WEBPACK FOOTER //
// ./app/components/pages/billing/charge_log/index.js